import * as React from 'react'

import { styled, spacing, Text, css } from '@thg-commerce/gravity-theme'

export interface ToggleButtonProps {
  children?: React.ReactNode
  selected?: boolean
  error?: boolean
  onClick?: (event?: React.SyntheticEvent) => void
  ref?: React.RefObject<HTMLInputElement>
}

const BorderColour = css<{ error: boolean }>`
  ${(props) =>
    props.error
      ? props.theme.colors.error.base
      : props.theme.colors.palette.greys.dark};
`

const StyledButton = styled.button<any>`
  ${Text('bodyText', 'alternate')};
  width: 100%;
  padding: ${spacing(3)};
  border: 2px solid ${BorderColour};
  text-decoration: none;
  color: ${(props) => props.theme.colors.palette.greys.darker};
  background-color: ${(props) =>
    props.selected
      ? props.theme.colors.palette.brand.lighter
      : props.theme.colors.palette.greys.white};

  &:first-child {
    border-top-left-radius: ${spacing(1)};
    border-bottom-left-radius: ${spacing(1)};
    border-right: solid 1px ${BorderColour};
  }

  &:last-child {
    border-top-right-radius: ${spacing(1)};
    border-bottom-right-radius: ${spacing(1)};
    border-left: solid 1px ${BorderColour};
  }

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.palette.brand.base};
  }

  &:hover {
    background-color: ${(props) => props.theme.colors.palette.brand.lighter};
  }
`

export const ToggleButton = (props: ToggleButtonProps) => {
  return (
    <StyledButton {...props} data-testid="toggle-button">
      {props.children}
    </StyledButton>
  )
}
